<div
  matTooltipPosition="above"
  [matTooltip]="tooltip() | translate"
  fxLayout="row"
  fxLayoutAlign="center center"
  fxLayoutGap="2px"
>
  <mat-icon class="mat-icon" [ngClass]="[color()]">
    {{icon()}}
  </mat-icon>
  <div class="color" [ngClass]="[color()]">
    {{ status() | translate | uppercase }}
  </div>
  @let alternativeInsurance = alternativeInsuranceName();
  @if(alternativeInsurance){
    <div class="alternative-insurance">
      <i> {{ alternativeInsurance }} </i>
    </div>
  }
</div>
